/*
 * producer (schema)
 */
import { boolean, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { users } from "../user/user.schema"

export const producers = schema.table("producers", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- General ---
	name: varchar("name", { length: 256 }).notNull(),
	shortName: varchar("short_name", { length: 64 }),
	contactName: varchar("contact_name", { length: 128 }),
	contactEmail: varchar("contact_email", { length: 256 }),
	contactPhone: varchar("contact_phone", { length: 32 }),
	contactFax: varchar("contact_fax", { length: 32 }),
	veteranFax: varchar("veteran_fax", { length: 32 }),
	website: varchar("website", { length: 512 }),
	orderWebsite: varchar("order_website", { length: 512 }),

	// --- Registration PDF ---
	pdfTemplateS3Key: varchar("pdf_template_s3_key", { length: 512 }),

	// --- Flags ---
	partnership: boolean("partnership").notNull().default(false),
	showInDropdown: boolean("show_in_dropdown").notNull().default(true),
	isTopicalProducer: boolean("is_topical_producer").notNull().default(false),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, { onDelete: "set null" }),
	updatedBy: uuid("updated_by").references(() => users.id, { onDelete: "set null" }),
})
